module.exports = __webpack_public_path__ + "static/media/onboarding12.a82ec255.svg";